import React from "react";

export const Mapex = () => {
  return (
    <div
    >
      <div
      style={{
        backgroundImage: `url(./images/new/mapexBG.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "58vh",
      }}>
        
      </div>
    </div>
  );
};